import React, { createContext, useState, useContext } from 'react';

const AuthContext = createContext(null);

// --- SIMULACIÓN DE BASE DE DATOS DE USUARIOS ---
const mockUsers = [
    {
        id: 'user-001',
        username: 'recepcion',
        password: '123',
        name: 'Ana López',
        clinicId: 'clinic-a',
        roles: ['recepcion']
    },
    {
        id: 'user-002',
        username: 'medico',
        password: '123',
        name: 'Dr. Alejandro Magno',
        clinicId: 'clinic-a',
        roles: ['medico']
    },
    {
        id: 'user-003',
        username: 'admin',
        password: '123',
        name: 'Gerardo M.',
        clinicId: 'clinic-b',
        roles: ['administracion', 'medico'] // Usuario con múltiples roles
    }
];

export const AuthProvider = ({ children }) => {
    // En una app real, esto vendría de un token, cookie, etc.
    const [user, setUser] = useState(null); 

    // Simula un inicio de sesión
    const login = (credentials) => {
        const foundUser = mockUsers.find(u => u.username === credentials.username && u.password === credentials.password);
        if (foundUser) {
            setUser(foundUser);
            return true; // Login exitoso
        }
        return false; // Login fallido
    };

    // Cierra la sesión
    const logout = () => {
        setUser(null);
    };

    const value = { 
        user, 
        isAuthenticated: !!user, 
        login, 
        logout 
    };

    return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
    return useContext(AuthContext);
};
